import React from 'react';
import { FaHome, FaPhone } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaBuilding } from "react-icons/fa";

const Contact = () => {
  return (
    <div className='container my-5'>
      <div className='mt-5'>
        <h2 style={{ color: "#757575" }}>Contact Us for Instant Support</h2>
        <p>"Buy Policy Now offers you Instant Support, call us and we will surprise you with our Quick Response"</p>
      </div>
      <div className='row'>
        {/* Registered Office */}
        <div className='col-md-4 col-sm-12 contact-card-bpn'>
          <div className='main-card-for-contact'>
            <div className='d-flex gap-3 align-items-center'>
              <div className='icon-background-for-contact'>
                <FaHome />
              </div>
              <h3 className='m-0'>Registered Office</h3>
            </div>
            <div>
              <hr />
              <p>
                Integrated Risk Insurance Brokers Limited<br />
                S.C.O. 201-203,<br />
                3rd Floor,<br />
                Sector 34-A,<br />
                Chandigarh – 160022.
              </p>
            </div>
          </div>
        </div>

        {/* Corporate Office */}
        <div className='col-md-4 col-sm-12 contact-card-bpn'>
          <div className='main-card-for-contact'>
            <div className='d-flex gap-3  align-items-center'>
              <div className='icon-background-for-contact'>
                <FaBuilding />
              </div>
              <h3 className='m-0'>Corporate Office</h3>
            </div>
            <div>
              <hr />
              <p>
                Integrated Risk Insurance Brokers Limited<br />
                908,<br />
                Embassy Centre,<br />
                Jamnalal Bajaj Marg,<br />
                Nariman Point,<br />
                Mumbai – 400021.
              </p>
            </div>
          </div>
        </div>

        {/* Inquiries */}
        <div className='col-md-4 col-sm-12 contact-card-bpn'>
          <div className='main-card-for-contact'>
            <div className='d-flex gap-3 align-items-center'>
              <div className='icon-background-for-contact'>
                <FaPhone />
              </div>
              <h3 className='m-0'>Inquiries</h3>
            </div>
            <hr />
            <div>
              <h5 className='mb-3'>Sales</h5>
              <p>
                <FaPhone /> <a href="tel:+919022264444">+91 9022264444</a> (Mon-Fri: 10 am to 7 pm)<br />
                <MdEmail /> <a href="mailto:info@buypolicynow.com">info@buypolicynow.com</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contact;
